import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import useStyles from "../../../components/common/model/styles";
import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { getLeadEstimateAction } from "../../../store/reducers/leadSlice";

const JobSurveyItems = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { surveyedItems } = useSelector((state: any) => state.leadSurvey);
  const { leadDetails, selectedLeadEstimate } = useSelector(
    (state: any) => state.lead
  );
  // ✅ Define allowed statuses
  const validStatuses = [
    "CONFIRMED",
    "JOB",
    "COMPLETED",
    "PROVISIONAL",
    "QUOTE",
  ];

  // ✅ Decide which data to show
  const showEstimateData = validStatuses.includes(leadDetails?.lead?.status);

  // ✅ Fetch estimate data if needed
  useEffect(() => {
    if (showEstimateData && leadDetails?.lead?.generated_id) {
      dispatch(
        getLeadEstimateAction({
          generatedId: leadDetails?.lead?.generated_id,
          screenType: "quotation",
        })
      );
    }
  }, [leadDetails]);


  // ✅ Compute material data based on status
  const materialData = useMemo(() => {
    const surveyRooms = surveyedItems?.list || [];

    if (showEstimateData) {
      return surveyRooms.map((room: any) => {
        if (room?.name?.toLowerCase() === "materials") {
          const estimateMaterials = selectedLeadEstimate?.materials || [];

          // Survey items ko map me store karo
          const surveyMap: Record<string, any> = {};
          room.items.forEach((item: any) => {
            surveyMap[item.item] = { ...item };
          });

          // Estimate items ko add karo as new columns if difference
          const finalItems = room.items.map((item: any) => {
            const estimateItem = estimateMaterials.find(
              (em: any) => em.name === item.item
            );
            if (estimateItem) {
              return {
                ...item,
                estimateQuantity: estimateItem.chargeQty,
                estimateFt3: estimateItem.volume,
                estimateTotal: estimateItem.total,
                estimateCost: estimateItem.cost,
              };
            }
            return item;
          });

          // Add new estimate items which are not in surveyedItems
          estimateMaterials.forEach((em: any) => {
            if (!surveyMap[em.name]) {
              finalItems.push({
                ...em,
                estimateQuantity: em.chargeQty,
                estimateFt3: em.volume,
                estimateTotal: em.total,
                estimateCost: em.cost,
              });
            }
          });

          return {
            ...room,
            items: finalItems,
          };
        }
        return room;
      });
    } else {
      return surveyRooms;
    }
  }, [showEstimateData, surveyedItems, selectedLeadEstimate]);



  return (
    <>
      <style>
        {`
          @media print {
            .print-bg {
              background-color: #dbdbdb !important;
              -webkit-print-color-adjust: exact; /* For Chrome */
              print-color-adjust: exact; /* For Firefox and IE */
            }
          }
        `}
      </style>
      <Grid container spacing={2} sx={{ marginTop: "10px !important" }}>
        <div
          className="print-bg"
          style={{
            background: "#E5F4F1",
            width: "100%",
            padding: "10px 16px",
            textAlign: "center",
            border: "1px solid #CFCFCF",
            borderRadius: "5px",
          }}
        >
          <Typography sx={{ color: "#394248", fontWeight: 700 }}>
            Survey Items
          </Typography>
        </div>
        {materialData?.length > 0 &&
          materialData?.map((room: any, roomIndex: number) => (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
              key={roomIndex}
            >
              <Table
                sx={{
                  border: "1px solid #CFCFCF",
                  borderRadius: "5px",
                  width: "100% !important",
                  // marginRight: roomIndex % 2 === 0 ? "16px" : "0px",
                  marginTop: "10px",
                }}
              >
                <TableHead sx={{ background: "#E5F4F1" }}>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      sx={{
                        width: "50%",
                        textAlign: "center",
                        fontWeight: 600,
                      }}
                    >
                      {room.name}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      sx={{ textAlign: "center", fontWeight: 600 }}
                    >
                      Ft³
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      sx={{ textAlign: "center", fontWeight: 600 }}
                    >
                      Qty
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      sx={{ textAlign: "center", fontWeight: 600 }}
                    >
                      Move Equipment
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {room.items.map(
                    (item: any, itemIndex: number) =>
                     (room.name === "Materials" || (item?.ft3 !== "0.00" && Number(item?.quantity) > 0)) && (
                        <TableRow
                          key={itemIndex}
                          sx={{ padding: "0px", textAlign: "center" }}
                        >
                          <TableCell
                            className={classes.tableCell}
                            sx={{ textAlign: "center" }}
                          >
                            {item.item || item.name}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            sx={{ textAlign: "center" }}
                          >
                            {item.ft3}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            sx={{ textAlign: "center" }}
                          >
                            {item?.estimateQuantity
                              ? item?.estimateQuantity
                              : item.quantity || 0}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            sx={{ textAlign: "center" }}
                          >
                            {item.linkedItem || "-"}
                          </TableCell>
                        </TableRow>
                      )
                  )}
                </TableBody>
              </Table>
            </div>
          ))}
      </Grid>
    </>
  );
};

export default JobSurveyItems;
